import React from 'react';
import { Typography, Card } from 'antd';
import MainLayout from '../components/MainLayout';

const { Title, Paragraph } = Typography;

function CalendarPage() {
  return (
    <MainLayout title="Scadenzario">
      <Card>
        <Title level={3}>Scadenzario</Title>
        <Paragraph>Vista calendario delle scadenze. (Placeholder)</Paragraph>
      </Card>
    </MainLayout>
  );
}

export default CalendarPage;
